<template>
  <div>
    <!--<v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>-->
    <v-container v-if="article && article.page">
      <div class="page-content">
        <div class="page-content-head">
          <h1 class="title-page" v-if="!article.page.hide_title">{{ article.page.transTitle}}</h1>
          <div class="indicator-3">
            <span class="cherry"></span>
            <span class="carrot"></span>
            <span class="purple"></span>
          </div>
        </div>
        <div class="page-content-body">
          <div class="news-pg discussion-pg">
            <div v-if="!article.page.hide_content" v-html="article.page.transContent"></div>
            <div class="discuss-body" v-if="article.projects">
              <div class="discussion-list">
                <div class="discussion-item" v-for="project in article.projects">
                  <div class="discuss-img" v-if="project.transImage">
                    <a class="waves-effect waves-light modal-trigger"
                       @click="dialog = true, dialogContent = project.transGoal">
                      <img :src="baseUrl + project.transFullImagesDirectory" alt="">
                    </a>
                  </div>
                  <div class="discuss-description">
                    <div v-html="project.transContent"></div>
                    <p v-if="project.transFile"><a :href="baseUrl + project.transFullFilesDirectory">Скачать проект
                      раздела</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="discuss-footer" v-if="article.content" v-html="article.content"></div>
      </div>
    </v-container>

    <v-dialog v-model="dialog">
      <v-card class="modal modal-default">
        <div class="modal-body">
          <div class="modal-content" v-html="dialogContent"></div>
        </div>
        <v-btn color="modal-close" @click.native="dialog = false">
          <img src="@/assets/img/cancel.png" alt="">
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import CMS from '@/model/cms'

  export default {
    components: {},
    data: () => ({
      article: null,
      breadcrumbs: [],
      baseUrl: process.env.VUE_APP_BACK_URL,
      dialog: false,
      dialogContent: ''
    }),
    watch: {
      // при изменениях маршрута запрашиваем данные снова
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        CMS.loadProjectBySlug(this.$route.params.slug)
          .then(response => {
            this.article = response.data
            this.breadcrumbs = [
              {
                text: 'Главная',
                disabled: false,
                href: '/'
              },
              {
                text: this.article.transTitle,
                disabled: true
              }
            ]
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    mounted () {
      this.fetchData()
    }
  }
</script>
